import { CancelToken } from 'axios'
import RecruiterDestinationCandidateClient from 'clients/user_notice/recruiter_destination_candidate_client'
import SpecialDestinationCandidateClient from 'clients/user_notice/special_destination_candidate_client'
import TagDestinationCandidateClient from 'clients/user_notice/tag_destination_candidate_client'
import { TARGET_REMOTE_NOTIFICATION } from 'entities/user_notice/constants/target_type'
import {
  CANCEL_FETCH_RECRUITER,
  CANCEL_FETCH_TAG,
  CHANGE_RECRUITER_KEYWORD,
  CHANGE_TAG_KEYWORD,
  FAILURE_FETCH_RECRUITER,
  FAILURE_FETCH_SPECIAL,
  FAILURE_FETCH_TAG,
  MOVE_RECRUITER_PAGE,
  MOVE_TAG_PAGE,
  SET_PARAM_KEY,
  SET_RECRUITER_DESTINATION_CANDIDATE_TARGET,
  SET_TAG_DESTINATION_CANDIDATE_TARGET,
  START_FETCH_RECRUITER,
  START_FETCH_SPECIAL,
  START_FETCH_TAG,
  SUCCESS_FETCH_RECRUITER,
  SUCCESS_FETCH_SPECIAL,
  SUCCESS_FETCH_TAG
} from '../constants/action_types'

const setParamKey = paramKey => ({
  type: SET_PARAM_KEY,
  payload: {
    paramKey
  }
})

const setRecruiterDestinationCandidateTarget = target => ({
  type: SET_RECRUITER_DESTINATION_CANDIDATE_TARGET,
  payload: {
    target
  }
})

export const startFetchRecruiters = source => ({
  type: START_FETCH_RECRUITER,
  payload: {
    source
  }
})

export const successFetchRecruiters = (recruiters, pagination) => ({
  type: SUCCESS_FETCH_RECRUITER,
  payload: {
    recruiters,
    pagination
  }
})

export const failureFetchRecruiters = error => ({
  type: FAILURE_FETCH_RECRUITER,
  payload: {
    error
  }
})

export const cancelFetchRecruiters = source => dispatch => {
  dispatch({
    type: CANCEL_FETCH_RECRUITER
  })

  source.cancel()
}

export const fetchRecruitersAsync = (page, keyword = null) => {
  const thunk = async (dispatch, getState) => {
    const { recruiter, form } = getState()
    const { source } = recruiter
    const { recruiterDestinationCandidateTarget: target } = form

    if (source !== null && typeof source !== typeof undefined) {
      return dispatch(cancelFetchRecruiters(source))
    }
    const newSource = CancelToken.source()
    dispatch(startFetchRecruiters(newSource))

    try {
      const {
        recruiterDestinationCandidates,
        pagination
      } = await RecruiterDestinationCandidateClient.getRecruiterDestinationCandidates(page, keyword, target)
      return dispatch(successFetchRecruiters(recruiterDestinationCandidates, pagination))
    } catch (error) {
      return dispatch(failureFetchRecruiters(error))
    }
  }

  thunk.meta = {
    throttle: 300
  }

  return thunk
}

export const startFetchTags = page => ({
  type: START_FETCH_TAG,
  payload: {
    page
  }
})

export const successFetchTags = (tags, pagination) => ({
  type: SUCCESS_FETCH_TAG,
  payload: {
    tags,
    pagination
  }
})

export const failureFetchTags = error => ({
  type: FAILURE_FETCH_TAG,
  payload: {
    error
  }
})

export const cancelFetchTags = source => dispatch => {
  dispatch({
    type: CANCEL_FETCH_TAG
  })

  source.cancel()
}

export const fetchTagsAsync = (page, keyword = null) => (dispatch, getState) => {
  const state = getState()
  const { source } = state.tag
  const { tagDestinationCandidateTarget } = state.form

  if (source !== null && typeof source !== typeof undefined) {
    return dispatch(cancelFetchTags(source))
  }

  const newSource = CancelToken.source()
  dispatch(startFetchTags(newSource))

  return TagDestinationCandidateClient.getTagDestinationCandidates(page, keyword, tagDestinationCandidateTarget, {
    source: newSource
  })
    .then(({ tagDestinationCandidates, pagination }) => {
      dispatch(successFetchTags(tagDestinationCandidates, pagination))
    })
    .catch(error => {
      dispatch(failureFetchTags(error))
    })
}

export const startFetchSpecials = () => ({
  type: START_FETCH_SPECIAL,
  payload: {}
})

export const successFetchSpecials = specials => ({
  type: SUCCESS_FETCH_SPECIAL,
  payload: {
    specials
  }
})

export const failureFetchSpecials = error => ({
  type: FAILURE_FETCH_SPECIAL,
  payload: {
    error
  }
})

export const fetchSpecialsAsync = () => dispatch => {
  dispatch(startFetchSpecials())

  return SpecialDestinationCandidateClient.getSpecialDestinationCandidates(TARGET_REMOTE_NOTIFICATION)
    .then(({ specialDestinationCandidates }) => {
      dispatch(successFetchSpecials(specialDestinationCandidates))
    })
    .catch(error => {
      dispatch(failureFetchSpecials(error))
    })
}

export const moveRecruitersPage = page => dispatch => {
  dispatch({
    type: MOVE_RECRUITER_PAGE,
    payload: {
      page
    }
  })

  dispatch(fetchRecruitersAsync(page))
}

export const moveTagsPage = page => dispatch => {
  dispatch({
    type: MOVE_TAG_PAGE,
    payload: {
      page
    }
  })

  dispatch(fetchTagsAsync(page))
}

export const changeRecruitersKeyword = keyword => (dispatch, getState) => {
  dispatch({
    type: CHANGE_RECRUITER_KEYWORD,
    payload: {
      keyword
    }
  })

  const state = getState()
  const page = state.recruiter.pagination.currentPage
  dispatch(fetchRecruitersAsync(page, keyword))
}

export const changeTagsKeyword = keyword => (dispatch, getState) => {
  dispatch({
    type: CHANGE_TAG_KEYWORD,
    payload: {
      keyword
    }
  })

  const state = getState()
  const page = state.recruiter.pagination.currentPage
  dispatch(fetchTagsAsync(page, keyword))
}

export const setTagDestinationCandidateTarget = target => ({
  type: SET_TAG_DESTINATION_CANDIDATE_TARGET,
  payload: {
    target
  }
})

export const initialize = (paramKey, recruiterDestinationCandidateTarget, tagDestinationCandidateTarget) => (
  dispatch,
  getState
) => {
  const state = getState()
  dispatch(setParamKey(paramKey))
  dispatch(setRecruiterDestinationCandidateTarget(recruiterDestinationCandidateTarget))
  dispatch(setTagDestinationCandidateTarget(tagDestinationCandidateTarget))
  dispatch(fetchRecruitersAsync(state.recruiter.pagination.currentPage))
  dispatch(fetchTagsAsync(state.tag.pagination.currentPage))
  dispatch(fetchSpecialsAsync())
}
